import React from 'react';
import { Typography } from 'antd';
import {
  string, shape, arrayOf, oneOf,
} from 'prop-types';
import I18n from 'i18n-js';
import ChangeRow from './ChangeRow';

const { Text } = Typography;

const HistoryItem = ({
  event = 'update',
  changedBy = null,
  createdAt = '',
  changes = [],
}) => {
  const action = event === 'create'
    ? I18n.t('tickets.history.created')
    : I18n.t('tickets.history.updated');

  return (
    <div className="ticket-history__item">
      <div className="ticket-history__item-header">
        <span className="ticket-history__item-actor">
          <Text strong>{changedBy?.username || I18n.t('tickets.history.unknown_actor')}</Text>
          <Text type="secondary">{` ${action}`}</Text>
        </span>
        <Text type="secondary" className="ticket-history__item-time">{createdAt}</Text>
      </div>

      {changes.length > 0 && (
        <div className="ticket-history__item-body">
          {changes.map((change) => (
            <ChangeRow key={change.attribute} {...change} />
          ))}
        </div>
      )}
    </div>
  );
};

HistoryItem.propTypes = {
  event: oneOf(['create', 'update']),
  changedBy: shape({ username: string, avatarUrl: string }),
  createdAt: string,
  changes: arrayOf(shape({})),
};

export default HistoryItem;
